import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMagnifierMinus32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMagnifierMinus32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M14.5 3C20.851 3 26 8.149 26 14.5c0 2.816-1.014 5.393-2.693 7.393l4.4 4.4a1 1 0 0 1-1.414 1.414l-4.4-4.4c-2 1.68-4.577 2.693-7.393 2.693C8.149 26 3 20.851 3 14.5S8.149 3 14.5 3m0 2a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19m4 8.5a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2z"
            />
        </svg>
    );
}
export default memo(IconMagnifierMinus32);
